import i18next from 'i18next';
import debounce from 'lodash.debounce';
import Notifications from 'react-notification-system-redux';

import {
  calculateMarginSuccess,
  toggleQuantityInputHasError,
  updateQuantityInputErrorMessage,
  toggleQuantityHasAPIError,
} from 'actions/placeorder';
import { estimateMargin } from 'actions/trade';
import { ERROR_CODES } from 'constants/constants';
import { addLogsInSentryAndMixpanel } from 'helpers/sentry';
import { parseErrorMsg } from 'helpers/utils';
import { userSelector } from 'selectors/otherSelectors';
import { generateOrderSelector } from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';

const getMarginPortfolio = () => (dispatch, getState) => {
  const state = getState();
  const order = generateOrderSelector(state);
  const selectedProduct = selectedProductSelector(state);
  const orderSize = order?.size;

  if (orderSize > 0) {
    dispatch(estimateMargin(order))
      .then(data => {
        const totalPortfolioMargin = data?.result?.additional_required_margin;
        const openingCommission = data?.result?.opening_commission || 0;
        const closingCommission = data?.result?.closing_commission || 0;

        dispatch(
          calculateMarginSuccess(
            totalPortfolioMargin,
            openingCommission,
            closingCommission
          )
        );
      })
      .catch(err => {
        const result = parseErrorMsg(err);
        const error = result?.error ?? '';
        const user = userSelector(state);

        if (error?.code === ERROR_CODES.TRADING_BLOCKED) {
          dispatch(
            Notifications.error({
              title: i18next.t('errors:custom.requestFailed'),
              message: i18next.t('errors:custom.trading_blocked'),
              position: 'bl',
            })
          );
          addLogsInSentryAndMixpanel(user, i18next.t('errors:custom.trading_blocked'));
        }

        if (error?.code === ERROR_CODES.PORTFOLIO_RISK_LIMITS_BREACHED) {
          const message = i18next.t('errors:placeOrder.requiredMarginTooHigh', {
            maxAllowed: error?.context?.max_notional_limit,
            underlyingSymbol: selectedProduct?.underlying_asset?.symbol,
          });
          dispatch(toggleQuantityInputHasError(true));
          dispatch(toggleQuantityHasAPIError(true));
          dispatch(updateQuantityInputErrorMessage(message));
          addLogsInSentryAndMixpanel(user, message);
        }
      });
  }
};

export default debounce(getMarginPortfolio, 300);
